<template>
  <b-row>
    <b-col cols="12" :lg="calculatorStatus === false ? 8 : 12">
      <b-form>
        <b-card>
          <b-spinner v-if="loading" class="align-middle mr-1" variant="secondary"></b-spinner>
          <b-card-text v-if="!tarifs.length">
            <h3 class="text-muted text-center">{{defaultInfo}}</h3>
          </b-card-text>
          <!-- Hardcoded, hide only for internet category, only available for partner app -->
          <b-card-text v-if="(category == 3 && !isAdminOrApprover)">
            <h3 class="text-muted text-center">Merujuk pada kebijakan masing-masing CFU</h3>
          </b-card-text>
          <b-card-text v-if="(calculatorStatus === true)">
            <div>
              <b-img
                :src="imgHidden"
                alt="Hidden image"
                fluid
                class="mx-auto d-block mb-3"
                style="max-width: 500px;"
              ></b-img>
            </div>
            <h4 class="text-muted text-center">{{ hiddenCalculatorMessage }}</h4>
          </b-card-text>
          <!-- v1 -->
          <div v-else v-for="item in tarifs" :key="item.PARENT" class="mb-1 px-1">
            <CartItem :root="root" :item="item" @addItem="addItems" :qos="qos" />
          </div>
        </b-card>
      </b-form>
    </b-col>
    <b-col v-if="calculatorStatus === false" cols="12" lg="4">
      <b-card title="ORDER PRICE">
        <div
          class="d-flex justify-content-between mb-1"
          v-for="cartItem in cartItems" :key="cartItem.index"
        >
          <div>
            <span>
              {{cartItem.root}} - {{cartItem.name}} - Qty ({{cartItem.qty}})
            </span>
            <b-link @click="clearItem(cartItem.index)" class="text-danger">
              <feather-icon icon="Trash2Icon" />
            </b-link>
          </div>
          <div class="ml-1">
            {{ new Intl.NumberFormat('id-ID').format(cartItem.price * cartItem.qty) }}
          </div>
        </div>
        <template #footer>
          <div class="d-flex justify-content-between">
            <div>Total</div>
            <div>
              Rp
              {{ new Intl.NumberFormat('id-ID').format(totalPriceItem($route.params.kode)) }}
            </div>
          </div>
        </template>
      </b-card>
      <div v-if="cartItems.length" class="d-flex justify-content-start mt-1">
        <router-link
          v-tracker="'button:total-cart'"
          :to="{
            name: 'product-calculator-total',
            params: { kode: $route.params.kode },
          }"
          class="d-flex text-body"
        >
        <b-button
          variant="primary"
        >
          Total Cart
        </b-button>
        </router-link>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormSpinbutton,
  BSpinner,
  BCard,
  BCardText,
  BCol,
  BRow,
  BForm,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormGroup,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BLink,
  BImg,
} from 'bootstrap-vue'
import CartItem from '@/views/user/product/calculator/CartItem.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    BCardText,
    BSpinner,
    BFormSpinbutton,
    BCol,
    BCard,
    BRow,
    BForm,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormGroup,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BLink,
    BImg,
    CartItem,
  },

  data() {
    return {
      root: '',
      category: null,
      defaultInfo: '',
      loading: false,
      interpolasiTypeOpt: [],
      interpolasiType: [],
      interpolasiVal: [],
      interpolasiLib: [],
      v2Parent: [],
      v2varParent: {},
      v3Parent: [],
      v3varParent: {},
      v4Parent: [],
      v4varParent: {},
      v5Parent: [],
      v5varParent: {},
      v6Parent: [],
      v6varParent: {},
      v7Parent: [],
      v7varParent: {},
      price: [],
      jumlah: [],
      tarifs: [{ zona: [{ layanan: [{}] }] }],
      qos: [],
      calculatorStatus: null,
      hiddenCalculatorMessage: "",
      imgHidden: require('@/assets/images/hiddenTarif.jpg'),
    }
  },

  computed: {
    ...mapGetters('calculator', ['totalPriceItem']),
    ...mapState('calculator', ['products','cartItems']),
    isAdminOrApprover() {
      let roles = this.$store.getters['oauth/getActiveUser'].role
      if (roles.includes('approver') || roles.includes('admin')) {
        return true
      }
      return false
    }
  },

  watch: {
    '$route.query.index': {
      handler: function(index) {
          this.loading = true
          this.initFetchTarif()
      },
      deep: true,
      immediate: true
    },
    v2Parent: function(val) {
      if(val !== []) {
        val.forEach((value,key) => {
          this.v2varParent[key] = value
          this.v2varParent[key]['v1_ID'] = key
          if(value.ITEM_PRICE_TYPE == 'FEATURES'){
            this.price[key] = value.LIST_PRICE
          }else if(this.price[key]) {
            
          }else{
            this.price[key] = false
          }
        });
      }
    },
    v3Parent: function(val) {
      let keyid = 0;
      val.forEach((value,key) => {
        keyid = key
        this.v3varParent[key] = value
        this.v3varParent[key]['v1_ID'] = key
        this.interpolasiTypeOpt[key] = [ ...new Set(this.clearSpace(this.interTypeParser(this.v2varParent[keyid].child))) ]
        this.interpolasiLib[key] = this.interLibParser(this.v2varParent[keyid].child)
        if(value.ITEM_PRICE_TYPE == 'FEATURES' && value.ITEM_NAME !== 'INTERPOLASI'){
          this.price[key] = value.LIST_PRICE
        }else if(this.price[key]) {
        }else{
          this.price[key] = false
        }
      });
    },
    v4Parent: function(val) {
      let keyid = 0;
      val.forEach((value,key) => {
        keyid = key
        this.v4varParent[key] = value
        this.v4varParent[key]['v1_ID'] = key
        this.interpolasiTypeOpt[key] = [ ...new Set(this.clearSpace(this.interTypeParser(this.v3varParent[keyid].child))) ]
        this.interpolasiLib[key] = this.interLibParser(this.v3varParent[keyid].child)
        if(value.ITEM_PRICE_TYPE == 'FEATURES' && value.ITEM_NAME !== 'INTERPOLASI'){
          this.price[key] = value.LIST_PRICE
        }else if(this.price[key]) {
        }else{
          this.price[key] = false
        }
      });
    },
    v5Parent: function(val) {
      let keyid = 0;
      val.forEach((value,key) => {
        keyid = key
        this.v5varParent[key] = value
        this.v5varParent[key]['v1_ID'] = key
        this.interpolasiTypeOpt[key] = [ ...new Set(this.clearSpace(this.interTypeParser(this.v4varParent[keyid].child))) ]
        this.interpolasiLib[key] = this.interLibParser(this.v4varParent[keyid].child)
        if(value.ITEM_PRICE_TYPE == 'FEATURES' && value.ITEM_NAME !== 'INTERPOLASI'){
          this.price[key] = value.LIST_PRICE
        }else if(this.price[key]) {
        }else{
          this.price[key] = false
        }
      })
    },
    v6Parent: function(val) {
      let keyid = 0;
      val.forEach((value,key) => {
        keyid = key
        this.v6varParent[key] = value
        this.v6varParent[key]['v1_ID'] = key
        this.interpolasiTypeOpt[key] = [ ...new Set(this.clearSpace(this.interTypeParser(this.v5varParent[keyid].child))) ]
        this.interpolasiLib[key] = this.interLibParser(this.v5varParent[keyid].child)
        if(value.ITEM_PRICE_TYPE == 'FEATURES' && value.ITEM_NAME !== 'INTERPOLASI'){
          this.price[key] = value.LIST_PRICE
        }else if(this.price[key]) {
        }else{
          this.price[key] = false
        }
      });
    },
    v7Parent: function(val) {
      let keyid = 0;
      val.forEach((value,key) => {
        keyid = key
        this.v7varParent[key] = value
        this.v7varParent[key]['v1_ID'] = key
        this.interpolasiTypeOpt[key] = [ ...new Set(this.clearSpace(this.interTypeParser(this.v6varParent[keyid].child))) ]
        this.interpolasiLib[key] = this.interLibParser(this.v6varParent[keyid].child)
        if(value.ITEM_PRICE_TYPE == 'FEATURES' && value.ITEM_NAME !== 'INTERPOLASI'){
          this.price[key] = value.LIST_PRICE
        }else if(this.price[key]) {
          }else{
          this.price[key] = false
        }
      });
    },
    interpolasiVal: function(val){
      val.forEach((value,key) => {
        this.interpolated(value,key)
      });
    }
  },
   mounted() {
    this.fetchTarifStatus()
    const mapRequest = {
      map: {
        PROD_CATEGORY: 'd',
      }
    }
    this.$http.post('/product/browse/id/'+this.$route.params.kode+'/set/first/published/true', mapRequest).then(response => { 
      this.category = response.data.data.records.PROD_CATEGORY
    })
  },
  methods: {
    async fetchTarifStatus() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_HELPER_URL}/product/calculator/hidden?product_kode=`+this.$route.params.kode, {
          headers: {
            'accept': 'application/json',
          },
        });
        
        const result = await response.json();
        this.calculatorStatus = result.data.is_hidden;
        this.hiddenCalculatorMessage = result.data.description
      } catch (error) {
        console.error('Error to get status tarif:', error);
      } finally {
        // this.isLoading = false;
      }
    },
    initFetchTarif() {
      this.$http.get(`/tarif-detail/${this.$route.params.kode}`).then(({ data }) => {
        console.log("data", data)
        this.interpolasiVal = []
        this.interpolasiLib = []
        this.v2Parent = []
        this.v2varParent = {}
        this.v3Parent = []
        this.v3varParent = {}
        this.v4Parent = []
        this.v4varParent = {}
        this.v5Parent = []
        this.v5varParent = {}
        this.v6Parent = []
        this.v6varParent = {}
        this.v7Parent = []
        this.v7varParent = {}
        this.tarifs = data.tarifs
        this.root = data.root.PRODUCT
        this.defaultInfo = this.setDefaultInfo(data.root.PRODUCT)
        this.qos = data.qos
        this.price = []
        this.jumlah = []
        this.tarifs.forEach((value,key) => {
          this.jumlah[value.PARENT] = 1
        })
        this.loading = false
      })
    },
    interpolated(val,key) {
      let rawArr = this.interpolasiLib[key].filter(e => {return e.name.includes(this.interpolasiType[key])})
      let arrVal = this.interLibParserAfter(rawArr)
      let min = Math.min(...arrVal)
      let max = Math.max(...arrVal)
      let notInter = this.interpolasiLib[key].filter(e => {return e.name == val})
      if(notInter.length){
        this.price[key] = notInter[0].price
      }else if(val > min && val < max){
        var bottom = 0;
        var top = 0;
        var hit = 0;
        rawArr.forEach(element => {
          if(parseInt(element.name) < val && hit == 0){
            bottom = element
          }else if(hit == 0){
            hit = 1
            top = element
          }
        })
        this.price[key] = this.interpolateCalc(bottom,top,val)
      }else{
        this.price[key] = 0
      }
    },
    interLibParser(val){
      return val.map(obj => {
        let reObj = {
          'name' : obj.ITEM_NAME,
          'price' : obj.LIST_PRICE
        }
        return reObj
      }).filter(obj => {
        return obj.price != null
      })
    },
    interLibParserAfter(val){
      return val.map(obj => {
        return obj.name.replace(/\D/g, "")
      })
    },
    interTypeParser(val){
      return val.map(obj => {
        return obj.ITEM_NAME.replace(/^\d+\s+/, "")
      }).filter(name => {
        return name !== 'INTERPOLASI'
      })
    },
    clearSpace(val){
      return val.map(obj => {
        return obj.trim()
      })
    },
    interpolateCalc(a,b,c){
      let x = parseFloat(c) - parseFloat(a.name);
      let y = parseFloat(b.name) - parseFloat(a.name)
      let tarif = a.price + ((x/y) * (parseFloat(b.price) - parseFloat(a.price)) )
      return tarif
    },
    addToCart(item,id,qty,price,interp,type) {
      let name = item;
      let product = {
        kode : id,
        root : this.root,
        prod_id : null,
        name : null,
        item_name: null,
        qty : null,
        price : null,
        type : null
      };
      if(this.v2Parent[id] ? this.v2Parent[id].ITEM_NAME : false){
        name = name+" - "+this.v2Parent[id].ITEM_NAME+ (this.v2Parent[id].HAS_CHILD == "N" ? "/"+this.v2Parent[id].ITEM_PAY_TYPE : "")
        if(this.v2Parent[id].HAS_CHILD == "N"){
          product.type = this.v2Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v2Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v2Parent[id].ITEM_NAME
        }
      }
      if(this.v3Parent[id] ? this.v3Parent[id].ITEM_NAME : false){
        name = name+" - "+(this.v3Parent[id].ITEM_NAME == 'INTERPOLASI' ? 'INTERPOLASI '+interp+' '+type : this.v3Parent[id].ITEM_NAME)+ (this.v3Parent[id].HAS_CHILD == "N" ? "/"+this.v3Parent[id].ITEM_PAY_TYPE : "")
        if(this.v3Parent[id].HAS_CHILD == "N"){
          product.type = this.v3Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v3Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v3Parent[id].ITEM_NAME
        }
      }
      if(this.v4Parent[id] ? this.v4Parent[id].ITEM_NAME : false){
        name = name+" - "+(this.v4Parent[id].ITEM_NAME == 'INTERPOLASI' ? 'INTERPOLASI '+interp+' '+type : this.v4Parent[id].ITEM_NAME)+ (this.v4Parent[id].HAS_CHILD == "N" ? "/"+this.v4Parent[id].ITEM_PAY_TYPE : "")
        if(this.v4Parent[id].HAS_CHILD == "N"){
          product.type = this.v4Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v4Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v4Parent[id].ITEM_NAME
        }
      }
      if(this.v5Parent[id] ? this.v5Parent[id].ITEM_NAME : false){
        name = name+" - "+(this.v5Parent[id].ITEM_NAME == 'INTERPOLASI' ? 'INTERPOLASI '+interp+' '+type : this.v5Parent[id].ITEM_NAME)+ (this.v5Parent[id].HAS_CHILD == "N" ? "/"+this.v5Parent[id].ITEM_PAY_TYPE : "")
        if(this.v5Parent[id].HAS_CHILD == "N"){
          product.type = this.v5Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v5Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v5Parent[id].ITEM_NAME
        }
      }
      if(this.v6Parent[id] ? this.v6Parent[id].ITEM_NAME : false){
        name = name+" - "+(this.v6Parent[id].ITEM_NAME == 'INTERPOLASI' ? 'INTERPOLASI '+interp+' '+type : this.v6Parent[id].ITEM_NAME)+ (this.v6Parent[id].HAS_CHILD == "N" ? "/"+this.v6Parent[id].ITEM_PAY_TYPE : "")
        if(this.v6Parent[id].HAS_CHILD == "N"){
          product.type = this.v6Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v6Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v6Parent[id].ITEM_NAME
        }
      }
      if(this.v7Parent[id] ? this.v7Parent[id].ITEM_NAME : false){
        name = name+" - "+(this.v7Parent[id].ITEM_NAME == 'INTERPOLASI' ? 'INTERPOLASI '+interp+' '+type : this.v7Parent[id].ITEM_NAME)+ (this.v7Parent[id].HAS_CHILD == "N" ? "/"+this.v7Parent[id].ITEM_PAY_TYPE : "")
        if(this.v7Parent[id].HAS_CHILD == "N"){
          product.type = this.v7Parent[id].ITEM_PAY_TYPE
          product.item_name = this.v7Parent[id].ITEM_NAME == 'INTERPOLASI' ? interp+' '+type : this.v7Parent[id].ITEM_NAME
        }
      }
      product.prod_id = this.$route.query.index
      product.name = name
      product.qty = qty
      product.price = price
      // {
      //     "kode": 5001,
      //     "root": "VPN IP",
      //     "prod_id": "1",
      //     "name": "ZONA TARIF - JABODETABEK - PAKET 3 - 512 Kbps/MONTHLY",
      //     "item_name": "512 Kbps",
      //     "qty": 1,
      //     "price": 3000000,
      //     "type": "MONTHLY"
      // }
      this.addItems(product)
      // .then(() => this.clearProduct())
    },
    clearProduct() {
      this.selectedArea = null
    },
    setDefaultInfo(val){ // temporary hardcoded
      const word1 = "Tarif Free";
      const word2 = "Kalkulator dapat diunduh dimenu tarif";
      const word3 = "Merujuk pada kebijakan masing-masing CFU";
      const word4 = "Lihat pada tabel Tarif";
      const word5 = "Struktur Tarif dan RDM mengikuti kebijakan eksisting masing-masing produk";
      switch (val.toLowerCase()) {
        case "SD-WAN Web Portal 2.0".toLowerCase():
          return word1;
          break;
        case "Manage SD-WAN Security on Box".toLowerCase():
          return word2;
          break;
        case "Managed SD-WAN Service 1.1".toLowerCase():
          return word2;
          break;
        case "Astinet Burstable".toLowerCase():
          return word3;
          break;
        case "IP Transit Burstable".toLowerCase():
          return word3;
          break;
        case "High Speed Internet (HSI)".toLowerCase():
          return word3;
          break;
        case "HSI 1 Gbps".toLowerCase():
          return word3;
          break;
        case "HSI FUP 2.0".toLowerCase():
          return word3;
          break;
        case "HSI Gamer".toLowerCase():
          return word3;
          break;
        case "HSI Hybrid".toLowerCase():
          return word3;
          break;
        case "HSI Prepaid".toLowerCase():
          return word3;
          break;
        case "HSI Pro".toLowerCase():
          return word3;
          break;
        case "HSI Quota".toLowerCase():
          return word3;
          break;
        case "HSI Streaming".toLowerCase():
          return word3;
          break;
        case "Renew Speed 3.0 (Add-On)".toLowerCase():
          return word3;
          break;
        case "Speed On Demand 3.0 (Add-On)".toLowerCase():
          return word3;
          break;
        case "Digital Targeted Advertising Solution (DARTS 2.0)".toLowerCase():
          return word4;
          break;
        case "Homespot".toLowerCase():
          return word4;
          break;
        case "iWifi".toLowerCase():
          return word4;
          break;
        case "LAN Over wifi".toLowerCase():
          return word4;
          break;
        case "OLIVE (Online Live Chat)".toLowerCase():
          return word4;
          break;
        case "Violet Go".toLowerCase():
          return word4;
          break;
        case "Welcome page Generator 5.0".toLowerCase():
          return word4;
          break;
        case "Wifi Basic".toLowerCase():
          return word4;
          break;
        case "SMS 99099".toLowerCase():
          return word4;
          break;
        case "Wifi Corner".toLowerCase():
          return word4;
          break;
        case "WicoPay".toLowerCase():
          return word4;
          break;
        case "Wifi id go".toLowerCase():
          return word4;
          break;
        case "Wifi Profiling Prepaid".toLowerCase():
          return word4;
          break;
        case "Wifi Seamless Prepaid".toLowerCase():
          return word4;
          break;
        case "WIFI STATION".toLowerCase():
          return word4;
          break;
        case "Wifi.id Volume Based".toLowerCase():
          return word4;
          break;
        case "Wifi.id X IndiBOX".toLowerCase():
          return word4;
          break;
        case "WISE (Wifi Seamless Community)".toLowerCase():
          return word4;
          break;
        case "WMS Lite 2.0".toLowerCase():
          return word4;
          break;
        case "WMS Lite 2.0 (untuk CFU EBIS)".toLowerCase():
          return word4;
          break;
        case "MyWifi.id".toLowerCase():
          return word1;
          break;
        case "sooltanNet Paket A".toLowerCase():
          return word5;
          break;
        case "sooltanNet Paket C".toLowerCase():
          return word5;
          break;
        case "SMS A2P International".toLowerCase():
          return word4;
          break;
        case "Vericall (Missed Call OTP)".toLowerCase():
          return word4;
          break;
        case "SMS A2P Domestik".toLowerCase():
          return word4;
          break;
        case "Sigtrans IP".toLowerCase():
          return word4;
          break;
        case "Yellow Pages".toLowerCase():
          return word4;
          break;
        case "Voice OTP".toLowerCase():
          return word4;
          break;
        case "Hosted PBX".toLowerCase():
          return word4;
          break;
        case "Hosted PBX Advance Service".toLowerCase():
          return word4;
          break;
        case "Hosted PBX Hot Billing".toLowerCase():
          return word4;
          break;
        case "Hosted PBX Multi Area Code".toLowerCase():
          return word4;
          break;
        case "Indihome Cloud".toLowerCase():
          return word4;
          break;
        case "Indihome Smart".toLowerCase():
          return word4;
          break;
        case "Cloud Storage untuk Indihome Smart".toLowerCase():
          return word4;
          break;
        case "Manage IP PBX".toLowerCase():
          return word4;
          break;
        case "Masking 150xyz".toLowerCase():
          return word4;
          break;
        case "Masking Number".toLowerCase():
          return word4;
          break;
        case "NeuAPIX".toLowerCase():
          return word4;
          break;
        case "New Permata".toLowerCase():
          return word4;
          break;
        case "New Permata Prepaid".toLowerCase():
          return word4;
          break;
        case "Permata for Business".toLowerCase():
          return word4;
          break;
        case "Signalling Internasional".toLowerCase():
          return word4;
          break;
        case "SMS A2P Smart Profiling - OCA".toLowerCase():
          return word4;
          break;
        case "sooltanNet".toLowerCase():
          return word4;
          break;
        case "sooltanNet Paket B".toLowerCase():
          return word4;
          break;
        case "sooltanNet Paket D".toLowerCase():
          return word4;
          break;
        case "sooltanNet Paket E".toLowerCase():
          return word4;
          break;
        case "SooltanNet Paket F".toLowerCase():
          return word4;
          break;
        case "Digiconnect Paket G dan Paket H".toLowerCase():
          return word4;
          break;
        case "sooltanNet Add On".toLowerCase():
          return word4;
          break;
        case "Bonum".toLowerCase():
          return word4;
          break;
        case "DigiERP".toLowerCase():
          return word4;
          break;
        case "DigiHotel".toLowerCase():
          return word4;
          break;
        case "Sakoo".toLowerCase():
          return word4;
          break;
        case "Telkom 2 Way SMS".toLowerCase():
          return word4;
          break;
        case "Telkom Free Call".toLowerCase():
          return word4;
          break;
        case "TELKOM Premium".toLowerCase():
          return word4;
          break;
        case "Telkom SLI 007".toLowerCase():
          return word4;
          break;
        case "Telkom SLJJ".toLowerCase():
          return word4;
          break;
        case "Triple Play Enterprise".toLowerCase():
          return word4;
          break;
        case "TV Storage UseeTV (NPVR)".toLowerCase():
          return word4;
          break;
        case "Virtual Local Number".toLowerCase():
          return word4;
          break;
        case "Trend Micro".toLowerCase():
          return word4;
          break;
        case "Telkom Unicall".toLowerCase():
          return word4;
          break;
        case "Telkom Split Charging".toLowerCase():
          return word4;
          break;
        case "Telkom Lokal".toLowerCase():
          return word4;
          break;
      
        default:
          return word4;
          break;
      }
    },
    ...mapActions('calculator', ['addItems', 'clearItem']),
  },
}
</script>